<template>
  <div class="row">
    <div class="col">
      <div class="card card-modern">
        <div>
          <div class="datatables-header-footer-wrapper">
            <div class="datatable-header card-body mb-3">
              <div class="row align-items-center mb-3">
                <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#upload-modal"
                    class="
                      btn btn-primary btn-md
                      font-weight-semibold
                      btn-py-2
                      px-4
                    "
                  >
                    <i class="bx bx-upload text-lg-4 py-1" /> Upload
                  </button>
                </div>
                <div class="col-8 col-lg-auto ms-auto ml-auto mb-3 mb-lg-0">
                </div>
                <div class="col-4 col-lg-auto ps-lg-1 mb-3 mb-lg-0">
                  <div
                    class="d-flex align-items-lg-center flex-column flex-lg-row"
                  >
                    <label class="ws-nowrap me-3 mb-0">Show:</label>
                    <select
                      class="form-control select-style-1 results-per-page"
                      name="results-per-page"
                      v-model="searchConfig.pageSize"
                      @change="changePageSize(searchConfig.pageSize)"
                    >
                      <option
                        :value="page"
                        v-for="page in pageSizeList"
                        :key="page"
                      >
                        {{ page }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-lg-auto ps-lg-1">
                  <div
                    class="search search-style-1 search-style-1-lg mx-lg-auto"
                  >
                    <div class="input-group">
                      <input
                        type="text"
                        class="search-term form-control"
                        placeholder="Search"
                        v-model="searchField"
                        @input="debounceInput"
                      />
                      <button class="btn btn-default" type="submit">
                        <i class="bx bx-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="dataTables_wrapper dt-bootstrap5 no-footer">
              <div class="row justify-content-between">
                <div class="col-auto"></div>
                <div class="col-auto"></div>
              </div>
            </div>
            <div>
              <div class="row row-gutter-sm">
                <div
                  class="col-sm-6 col-md-4 col-xl-2 mb-3 d-flex"
                  v-for="(item, index) in library"
                  :key="index"
                >
                  <div class="card card-modern card-modern-alt-padding w-100">
                    <div class="card-body p-2 bg-light" :title="item.fileName">
                      <div class="image-frame mb-2">
                        <div class="image-frame-wrapper" @click="openDocumentInNewTab(item)" style="cursor: pointer;">
                          <photo :src="`${baseUrl}${item.url}`" v-if="item.fileType === fileTypes.IMAGE" />
                          <photo
                            v-if="item.fileType === fileTypes.PDF"
                            src="https://cdn-icons-png.flaticon.com/512/80/80942.png"
                          />
                        </div>
                      </div>
                      <small class="file-name clickable" @click="openDocumentInNewTab(item)">
                        {{ item.fileName }}
                      </small>
                      <div class="d-flex justify-content-between image-action">
                        <div class="checkbox-custom checkbox-default">
                          <input type="checkbox" v-model="selected" :value="item.id" />
                          <label></label>
                        </div>
                        <div class="d-flex">
                          <div
                            class="cursor-pointer"
                            v-if="item.fileType === fileTypes.PDF"
                            @click="copyPathToClipboard(item)"
                            title="Kopiraj u medjuspremnik"
                          >
                            <i class="bx bx-copy text-5" />
                          </div>
                          <div class="cursor-pointer" @click="checkImageForUsage(item.id)">
                            <i class="bx bx-trash text-5" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr class="solid mt-5 opacity-4" />
            <div class="datatable-footer">
              <div class="row align-items-center justify-content-between mt-3">
                <div class="col-md-auto order-1 mb-3 mb-lg-0">
                  
                  <button type="button" class="cancel-button  btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3" @click="checkMediaLibraryUsage()">
                    Izbrisi <i class="bx bx-trash text-5" />
                  </button>
                </div>
                <div class="row row-gutter-sm justify-content-between mt-4">
                  <pagination :action="actionName" :pagination-props="paginationProps" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal id="upload-modal" css-class="modal-xl">
      <h5 slot="header">
        <strong> Upload image </strong>
      </h5>
      <div slot="body">
        <MediaLibraryModalBody modal-id="upload-modal" />
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent="closeModal"
            >
              Zatvori
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal id="delete-modal" css-class="modal-xl">
      <h5 slot="header">
        <strong>Izbrisati slike? </strong>
      </h5>
      <div slot="body">
        <div
          class="alert"
          :class="messageType === 'ERROR' ? 'alert-danger' : 'alert-info'">
          {{ message }}
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-danger px-4 mx-2"
              @click.prevent="deleteImages()"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent="closeDeleteModal()"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- end: page -->
  </div>
</template>

<script>
import { translations, pager } from "@/mixins";
import Pagination from "@/components/shared/Pagination.vue";
import Modal from "@/components/shared/modal/Modal.vue";
import Photo from "@/components/shared/Photo.vue";
import MediaLibraryModalBody from "@/components/shared/MediaLibraryModal.vue";

import config from "@/config";
import helpers from '@/services/helpers';
import api from '@/services/api';

import { EventBus } from '../main';

export default {
  name: "MediaLibrary",
  components: {
    Pagination,
    Modal,
    Photo,
    MediaLibraryModalBody,
  },
  mixins: [translations, pager],
  data() {
    return {
      actionName: "getMediaLibrary",
      selected: [],
      message: '',
      messageType: 'ERROR'
    };
  },
  computed: {
    articleModalText() {
      return this.translations.areYouSureSelected;
    },
    library() {
      return this.$store.getters.getMediaLibrary;
    },
    baseUrl() {
      return config.baseUrl;
    },
    fileTypes() {
      return helpers.mediaFileTypes;
    },
    paginationProps() {
      return {
        quickSearch: this.searchField.trim(),
      };
    },
  },
  methods: {
    closeModal() {
      $('#upload-modal').modal('hide');
      EventBus.$emit('clear-upload-modal-data:upload-modal');
    },
    closeDeleteModal() {
      $('#delete-modal').modal('hide');
    },
    checkMediaLibraryUsage() {
      api.checkMediaLibraryUsage(this.selected).then((response) => {
        this.message = response.data.info;
        this.messageType = 'INFO'
      }).catch((err) => {
        this.message = err.response.data.info;
        this.messageType = 'ERROR';
      }).finally(() => {
        $('#delete-modal').modal('show');
      });
    },
    deleteImages() {
      api.deleteMediaLibraryFiles(this.selected).then((response) => {
        this.$toast.info(response.data.info);
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      }).finally(() => {
        this.selected = [];
        this.$store.dispatch(this.actionName, this.searchConfig);
        this.closeDeleteModal();
      });
    },
    checkImageForUsage(id) {
      this.selected = [id];
      this.checkMediaLibraryUsage();
    },
    openDocumentInNewTab(item) {
      const url = `${config.baseUrl}${item.url}`;
 
      window.open(url, '_blank');
    },
    copyPathToClipboard(item) {
      navigator.clipboard.writeText(`${config.baseUrl}${item.url}`).then(() => {
        this.$toast.info('Kopirano u medjuspremnik');
      });
    },
  },
  mounted() {
    this.$store.dispatch(this.actionName, this.searchConfig);
  },
};
</script>
<style lang="scss" scoped>
.image-action div {
  > .bx {
    color: #000;
  }
}

.file-name {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cursor-pointer {
  cursor: pointer;
}

.clickable {
  cursor: pointer;
}

.clickable:hover {
  color: #007bff;
  text-decoration: underline;
}
</style>